import util from '@/tools/commonUtil'
import dateUtil from '@/tools/dateUtil'
const validQuLogics = function (question, logic, quItem, toQuItem, value, anQuItemId, anValue) {
  let isShow = true
  const { scoreQuType } = quItem
  const { chooseType, logicType, geLe, minValue, maxValue } = logic
  if ([1, 'question'].includes(logicType) || [2, 'clientProperty'].includes(logicType)) {
    isShow = commonValidLogic(quItem, chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue)
    if (!isShow) {
      return isShow
    }
  } else if (logicType === '3' || logicType === '4') {
    if (!commonValidLogic(quItem, chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue)) {
      this.setLogicValue(logic, toQuItem)
    }
  }
  return isShow
}
const getQuBeforLogicsExpress = function (logic, quItem, value, anQuItemId, anValue) {
  let resultStr = ''
  const { chooseType, geLe, minValue, maxValue } = logic
  const { scoreQuType } = quItem
  resultStr = !commonValidLogic(quItem, chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue)
  return resultStr
}

const commonValidLogic = (quItem, chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue) => {
  let isShow = true
  if (scoreQuType === '1') {
    if (geLe === '1') {
      if (util.isContainsArr(value, anValue)) {
        isShow = false
        return false
      }
    } else {
      value = value[0]
      anValue = anValue[0]
      if (geLe === '2') {
        if (value >= minValue && value <= maxValue) {
          isShow = false
          return false
        }
      } else if (geLe === '3') {
        if (value < anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '4') {
        if (value <= anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '5') {
        if (value > anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '6') {
        if (value >= anValue) {
          isShow = false
          return false
        }
      }
    }
  } else {
    const { scoreQuParagraph } = quItem
    anValue = anValue * 1
    if (scoreQuType === '2') {
      anValue = dateUtil.date2Str(new Date(anValue), 'HHmm')
    } else if (scoreQuType === '3') {
      if (scoreQuParagraph === '1') {
        anValue = dateUtil.date2Str(new Date(anValue), 'yyyyMM')
      } else if (scoreQuParagraph === '2') {
        anValue = dateUtil.date2Str(new Date(anValue), 'yyyyMMdd')
      }
    } else if (scoreQuType === '4') {
      anValue = anValue + ''
    }
    if (geLe === '1') {
      if (util.isContainsArr(value, anValue)) {
        isShow = false
        return false
      }
    } else {
      value = value[0]
      if (geLe === '2') {
        if (value >= anValue && value <= anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '3') {
        if (value > anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '4') {
        if (value >= anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '5') {
        if (value < anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '6') {
        if (value <= anValue) {
          isShow = false
          return false
        }
      }
    }
  }
  return isShow
}

const logic = {
  validQuLogics,
  getQuBeforLogicsExpress
}

export default logic



// WEBPACK FOOTER //
// ./src/components/editor/NumberBox/logic.js